import React from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { has, isEmpty } from 'lodash'
import legolasApi from '../../api/legolas'
import {
    List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup,
    TableContainer, Table, TableHead, TableBody, TableRow, Paper, Modal
} from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import globalConfig from '../../utils/globalConfig'
import { StyledTableCell, StyledTableRow } from '../common/StyledTableElements'
import EditIcon from '@mui/icons-material/Edit';
import { remove, isArray } from 'lodash';

function OrderReturnList(props) {
    const [listData, setListData] = React.useState([])
    const [dataCount, setDataCount] = React.useState(0)
    const [selectedHeaders, setSelectedHeaders] = React.useState([
        { id: 'increment_id', label: 'ID' }, { id: 'created_at', label: 'Request Date' }, { id: 'order_id', label: '#order' },
        { id: 'status', label: 'status' }
    ])
    const navigate = useNavigate()
    const { summary, items, shipment, transaction, customer } = props.data

    const localStorageUser = localStorage.getItem('user');
	const user = JSON.parse(localStorageUser);
	const userid = user.id

    React.useEffect(() => {
        console.log("list data", listData)
    }, [listData])

    React.useEffect(() => {
        let submitPayload = {
            "orderId": summary.order_id,
            "type": "return"

        }
        axios.post(`${legolasApi.url}/orders/order/particular`, submitPayload).then((res) => {
            console.log('Response: ', res)
            const data = res.data
            if (data) {
                setListData(res.data.data);
                console.log("data list", res.data.data)
            } else {
                setListData([])
            }

            console.log(res.data);
        })
    }, [])

    const EditReturnHandler = (rma) => {
        const link = `/edit-return/${rma.entity_id}`
        navigate(link, { state: { data: rma } })
    }

    const formatDateAndTime = (inpDate) => {
        let retDate = ''
        const month = inpDate.toLocaleDateString('default', { month: 'short' })
        const date = inpDate.getDate()
        const year = inpDate.getFullYear()
        const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
        return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
    }


    return (
        <List actions={null}>
            <Box sx={globalStyles.headerWrapperBox}>
                <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
                    <Typography variant='h4'>Manage Returns</Typography>
                    <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
                    </Typography>
                </Box>
            </Box>
            <Box>
                {
                    !isEmpty(listData) ?
                        <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
                            <Table aria-label="simple table">
                                <TableHead sx={{
                                    backgroundColor: globalStyles.colors.backgroundPrimary,
                                    height: '40px !important',
                                    borderRadius: '0 !important',
                                    '& .MuiTableCell-root': {
                                        color: '#fff !important',
                                        padding: '10px !important',
                                        borderRight: '2px solid #fff !important',
                                        borderRadius: '0 !important'
                                    }
                                }}>
                                    <TableRow>
                                        {selectedHeaders.map((header) => [
                                            <StyledTableCell align='center'>{header.label}</StyledTableCell>
                                        ])}
                                        <StyledTableCell align='center'>Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                {/* <TableBody>
                            {listData.map(rma => {
                                return (
                                    <StyledTableRow>
                                        {selectedHeaders.map((header) => {
                                            if (header.id == 'status' && has(globalConfig.rmaStatus, rma['status'])) {
                                                return (
                                                    <StyledTableCell align='center'>
                                                        <Typography
                                                            sx={{
                                                                fontSize: '14px',
                                                                backgroundColor: globalConfig.rmaStatus[rma['status']].color,
                                                                color: '#fff',
                                                                padding: '4px 8px'
                                                            }}
                                                        >
                                                            {globalConfig.rmaStatus[rma['status']].text}
                                                        </Typography>
                                                    </StyledTableCell>
                                                )
                                            } else {
                                                return (
                                                    <StyledTableCell align='center'>
                                                        {rma[header.id]}
                                                    </StyledTableCell>
                                                )
                                            }
                                        })}
                                        <StyledTableCell align='center'>
                                        <Button  onClick={() => EditReturnHandler(rma)}>View</Button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                            })}
                        </TableBody> */}
                                <TableBody>
                                    {/* {selectedHeaders.map((header)=>{
                                 if (header.id === 'created_at') {
                                    return (
                                      <StyledTableCell align='center'>{formatDateAndTime(new Date(listData[header.id]))}</StyledTableCell>
                                    )
                                 }
                                    else
                                return (
                                    <StyledTableCell>{listData[header.id]}</StyledTableCell>
                                )
                            })} */}


                                    {listData.map((order) => {
                                        return (
                                            <StyledTableRow id={order.id}>
                                                {selectedHeaders.map((header) => {
                                                    if (header.id === 'created_at') {
                                                        return (
                                                            <StyledTableCell align='center'>{formatDateAndTime(new Date(order[header.id]))}</StyledTableCell>
                                                        )
                                                    } else {
                                                        return (
                                                            <StyledTableCell align='center'>
                                                                {order[header.id]}
                                                            </StyledTableCell>
                                                        )
                                                    }
                                                })}
                                                <StyledTableCell align='center'>
                                                    {!(userid === 159 && userid === 160) ? <Button onClick={() => EditReturnHandler(order)} >View</Button> : null}                                      
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        </TableContainer>
                        :
                        <Box>
                            <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontStyle: 'oblique' }}>No items added in return</Typography>
                        </Box>
                }
            </Box>
        </List>
    )
}

export default OrderReturnList